import { render } from "./EditProfileComponent.vue?vue&type=template&id=2a2c834d"
import script from "./EditProfileComponent.vue?vue&type=script&lang=js"
export * from "./EditProfileComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__